import { AuthEnums } from 'dashboard-services/api/auth';
import { ReduxService } from 'dashboard-services/services';

import { companyMyAccountActions } from 'actions/modules/myAccount';

const EMPTY_COMPANY_METADATA_FIELD = {
  companyMetadataId: undefined,
  defaultValue: "", 
  isRequired: false, 
  isEditValueMode: false,
  metadataKey: "",
  metadataValue: "",
}

export const companyInitialState = {
  sortBy: "email",
  sortOrder: "asc",

  // modals control
  addUserIsOpen: false,
  editCompanyIsOpen: false,
  editCompanyMetadataIsOpen: false,
  //
  
  companyDetails: {
    companyId: undefined,
    companyAuthType: "",
    companyMetadata: [],
    companyName: "",
    companyTags: [],
    metadataRemovalOption: AuthEnums.COMPANY_METADATA_REMOVAL_OPTIONS.DECOUPLE_FROM_COMPANY_ONLY,
    initialCompanyAuthType: "",
    initialCompanyMetadata: [],
    initialCompanyName: "",
    initialCompanyTags: []
  },

  rolesHasNextPage: false,
  roles: [],
  rolesTotalSize: 0
}

export default (state = companyInitialState, action) => {
  switch (action.type) {
    case companyMyAccountActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case companyMyAccountActions.ON_CHANGE_DETAILS: {
      const modifiedCompanyDetails = ReduxService.updateObject(state.companyDetails, {
        [action.name]: action.value
      })
      return ReduxService.updateObject(state, { companyDetails: modifiedCompanyDetails })
    }
    case companyMyAccountActions.ADD_COMPANY_METADATA_FIELD: {
      const modifiedCompanyMetadata = state.companyDetails.companyMetadata.add({ ...EMPTY_COMPANY_METADATA_FIELD }),
            modifiedCompanyDetails = ReduxService.updateObject(state.companyDetails, { companyMetadata: modifiedCompanyMetadata })

      return ReduxService.updateObject(state, { companyDetails: modifiedCompanyDetails })
    }
    case companyMyAccountActions.CHANGE_COMPANY_METADATA_FIELD: {
      const modifiedCompanyMetadata = state.companyDetails.companyMetadata.updateInList({ [action.name]: action.value }, action.index), 
            modifiedCompanyDetails = ReduxService.updateObject(state.companyDetails, { companyMetadata: modifiedCompanyMetadata })

      return ReduxService.updateObject(state, { companyDetails: modifiedCompanyDetails })
    }
    case companyMyAccountActions.REMOVE_COMPANY_METADATA_FIELD: {
      const modifiedCompanyMetadata = state.companyDetails.companyMetadata.remove(action.index), 
      modifiedCompanyDetails = ReduxService.updateObject(state.companyDetails, { companyMetadata: modifiedCompanyMetadata })

      return ReduxService.updateObject(state, { companyDetails: modifiedCompanyDetails })
    }
    case companyMyAccountActions.CLEAR_COMPANY:
      return companyInitialState
    default:
      return state;
  }
}